import { api } from "constants/RotasAPI";
import usePost from "hooks/usePost";
import { queryClient } from "shared/util/queryClient";

export const usePostAtivarCondominioGroupPay = () => {
  const onSuccess = () => {
    queryClient.invalidateQueries(["tabela-condominios-group-pay"]);
  };

  const { mutate, ...rest } = usePost({
    url: api.groupPay.postAtivarCondominio,
    skipGlobalLoading: true,
    onSuccess,
  });

  const adaptedMutate = (idOrIds: number | number[]) => {
    const ids = Array.isArray(idOrIds) ? idOrIds : [idOrIds];
    return mutate({ ids: ids });
  };

  return {
    ...rest,
    mutate: adaptedMutate,
  };
};
